export default __webpack_public_path__ + "static/media/logo-bg-transparent.c436da20.svg";